module.exports = __webpack_public_path__ + "img/weather_sunset.cf01f54e.svg";